import { render, staticRenderFns } from "./AssetsPreview.vue?vue&type=template&id=47a1625e&"
import script from "./AssetsPreview.vue?vue&type=script&lang=js&"
export * from "./AssetsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports